import React from 'react';
import FlowDiagram from './components/FlowDiagram';
export function App() {
  return <div className="w-full h-screen bg-gradient-to-b from-gray-900 to-blue-900" data-id="element-0">
      <FlowDiagram data-id="element-1" />
    </div>;
}